<template>
  <div id="timeline" class="timeline">
    <EpochJVM
        v-for="epoch in store.epochs"
        :key="epoch.id"
        :epoch="epoch"
    />
  </div>
</template>

<script lang="ts" setup>
import { useTimelineMapStore } from "@features/Pages/TimelineMapPage/_js/app/store/timelineMapStore";
import EpochJVM from "../epoch/EpochJVM.vue";

const store = useTimelineMapStore();
</script>
